<template>
  <div>
    <Button
      v-if="data.length > 0"
      @click.native="!isCustomExport ? descExcel() : exportExcelCustom()"
      :size="20"
      text="Exportar Excel"
      color="#28a745"
      colorText="#ffffff"
      tooltip="Exportar"
      icon="fas fa-file-excel"
      round
      :width="130"
      :height="30"
      class="mb-3"
      horizontal
    />
  </div>
</template>

<script>
import exportFromJSON from "export-from-json";
import Button from "../../components/common/Button";

export default {
  props: {
    headers: Array,
    data: Array,
    isCustomExport: Boolean,
    exportExcelCustom: { type: Function, default: () => ({}) },
    nombreArchivo: {
      type: String,
      default: "download",
    },
  },
  data() {
    return {
      dataHeaders: this.headers,
    };
  },
  components: {
    Button,
  },
  methods: {
    descExcel() {
      let headerValue = [];

      for (let d of this.data) {
        for (let index in d.data) {
          headerValue.push(this.headers[index].title);
        }
        break;
      }

      let arrTemp = [];

      this.data.map((val) => {
        let dataTemporal = {};

        headerValue.map((hValue, index) => {
          if( hValue == "Depósito" ){

            dataTemporal[hValue] = val.seleccionados_aux.deposito.name !== undefined 
                  ? val.seleccionados_aux.deposito.name
                  : "";

          } else if( hValue == "Vía" ) {
            
            dataTemporal[hValue] = val.seleccionados_aux.via.name !== undefined 
                  ? val.seleccionados_aux.via.name
                  : "";

          } else {
            dataTemporal[hValue] = val.data[index];
          }
        });

        arrTemp.push(dataTemporal);
      });

      const data = arrTemp;
      const fileName =
        this.nombreArchivo +
        " " +
        new Date().toLocaleDateString() +
        "_" +
        new Date().toLocaleTimeString();
      const exportType = exportFromJSON.types.xls;

      exportFromJSON({ data, fileName, exportType });
    },
  },
};
</script>
